import { useRef, useState } from 'react'
import { createPortal } from 'react-dom'

type ReportTextCellProps = {
  value?: string | number | null
}

type TooltipPosition = {
  top: number
  left: number
}

export function ReportTextCell({ value }: ReportTextCellProps) {
  const text = value == null ? '' : String(value)
  const triggerRef = useRef<HTMLSpanElement>(null)
  const [tooltipPosition, setTooltipPosition] = useState<TooltipPosition | null>(null)

  const showTooltip = () => {
    if (!text || !triggerRef.current) return

    const rect = triggerRef.current.getBoundingClientRect()
    const maxWidth = 320
    const left = Math.min(Math.max(rect.left, 8), window.innerWidth - maxWidth - 8)

    setTooltipPosition({
      top: rect.bottom + 6,
      left,
    })
  }

  const hideTooltip = () => setTooltipPosition(null)

  return (
    <>
      <span
        ref={triggerRef}
        className="block overflow-hidden text-ellipsis whitespace-nowrap"
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        onFocus={showTooltip}
        onBlur={hideTooltip}
        tabIndex={text ? 0 : undefined}
      >
        {text}
      </span>
      {tooltipPosition &&
        createPortal(
          <span
            role="tooltip"
            className="pointer-events-none fixed z-50 max-w-80 rounded-sm border border-borderGray bg-white px-3 py-2 text-sm text-primaryText shadow-soft whitespace-normal break-words"
            style={{
              top: tooltipPosition.top,
              left: tooltipPosition.left,
            }}
          >
            {text}
          </span>,
          document.body,
        )}
    </>
  )
}
